const { resolve } = require('path');

module.exports = {
  module: {
    load: (ns, lng) => import(`../locales/${lng}/${ns}.json`),
    getFilepath: (ns, lng) => resolve(__dirname, '..', 'locales', lng, ns) + '.json',
    namespaces: ['conversion', 'exception', 'success', 'validator'],
    langs: ['en', 'es', 'ru'],
  },
};
